import { storeRef } from "@/components/providers/StoreProvider"
import { useAppSelector } from "@/lib/redux/hooks"
import dayjs from "dayjs"

export const checkIsValidInputFlights = () => {
  const flightState = storeRef.current?.getState().flight
  const inputFlights = (flightState?.inputFlights || []).map(input => {
    let dForm: any = input.dateFrom
    let dTo: any = input.dateTo

    if (!dayjs.isDayjs(dForm)) {
      dForm = dayjs(dForm)
      if (!dForm.isValid()) {
        dForm = dayjs()
      }
    }

    if (!dayjs.isDayjs(dTo)) {
      dTo = dayjs(dTo)
      if (!dTo.isValid()) {
        dTo = dayjs()
      }
    }

    return {
      ...input,
      dateFrom: dForm,
      dateTo: dTo
    }
  })

  let isValidInput = false
  const now = dayjs()
  if (flightState?.checkedItinerary && !flightState.isMultiCities) {
    const fligthDepartment = inputFlights.find(f => !f.isReturn)
    const days = fligthDepartment?.dateTo.diff(fligthDepartment?.dateFrom, 'days')
    isValidInput = days >= 0
  } else {
    isValidInput = inputFlights.every(input => input.dateFrom.diff(now, 'days') >= 0)
  }
  return isValidInput
}